module.exports = __webpack_public_path__ + "images/emoji/ram.833d976538f59bd99f46.png";